import { QUIZ_STATUSES, STATUS_PROMOTION } from '../_constants/learningStatuses';

interface Params {
  initialStatus?: (typeof QUIZ_STATUSES)[number];
  isOnHomePage: boolean;
  userIsFollowingCourse: boolean;
}

type LearningStatus = {
  status: (typeof QUIZ_STATUSES)[number];
};

const useQuizLearningStatus = ({
  initialStatus = 'not started',
  isOnHomePage,
  userIsFollowingCourse,
}: Params): LearningStatus => {
  if (!userIsFollowingCourse && isOnHomePage) {
    return { status: STATUS_PROMOTION };
  }

  return { status: initialStatus };
};

export default useQuizLearningStatus;
